var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-error-box"},[_c('el-empty',{attrs:{"description":"404","image-size":400}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }